import React from 'react';
import PropTypes from 'prop-types';

const Amount = ({ value, currency }) => {
  if (value === null || typeof value === 'undefined' || !currency) return '';

  const amount = new Intl.NumberFormat(I18n.locale, {
    style: 'currency',
    currency,
  }).format(value);

  return <span>{amount}</span>;
};

Amount.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currency: PropTypes.string.isRequired,
};

export default Amount;
